import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { CategoryType } from '@data/sdk/match';

interface DynamicQuestionsFiltersState {
  categories: {
    label: string;
    type: CategoryType;
    value: string;
  }[];
  clearCategories: () => void;
  setCategories: (categoryId: string, categoryLabel: string, categoryType: CategoryType) => void;
}

export const useDynamicQuestionsFiltersStore = create<DynamicQuestionsFiltersState>()(
  persist(
    (set) => ({
      categories: [],
      setCategories: (categoryId: string, categoryLabel: string, categoryType: CategoryType) => {
        set(({ categories }) => {
          const category = categories.find((c) => c.value === categoryId);

          return {
            categories: category
              ? categories.filter((c) => c.value !== categoryId)
              : [...categories, { label: categoryLabel, value: categoryId, type: categoryType }],
          };
        });
      },
      clearCategories: () => {
        set(() => ({ categories: [] }));
      },
    }),

    {
      name: 'dynamic-questions-filters',
    },
  ),
);

export const clearDynamicQuestionsFiltersStore = () =>
  useDynamicQuestionsFiltersStore.persist.clearStorage();
